export default "__VITE_ASSET__DqbvYTOr__"